import { cnpj as cnpjValidator } from 'cpf-cnpj-validator';

export const MASCARA_CNPJ = 'XX.XXX.XXX/XXXX-##';

export const cnpj = cnpjValidator;

export function regrasCnpj() {
    return [
        val => val && val.length === 14 || 'Por favor, digite o seu CNPJ igual está no documento.',
        val => val && cnpj.isValid(val) || 'Este CNPJ parece estar incorreto, por favor, verifique para erros de digitação.',
    ];
}

export function normalizarCnpj(valor) {
    return valor ? cnpj.strip(valor) : valor;
}

export function formatarCnpjExibicao(valor) {
    if (!valor) {
        return valor;
    }

    const normalizado = cnpj.strip(valor);

    return normalizado.length === 14 ? cnpj.format(normalizado) : valor;
}
